var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaspiLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40H7.27305C7.27305 40 7.27305 40.0001 7.27305 40.0001C7.27305 58.0749 21.9255 72.7274 40.0003 72.7274C58.0751 72.7274 72.7276 58.0749 72.7276 40.0001C72.7276 21.9254 58.0751 7.27285 40.0003 7.27285C40.0002 7.27285 40.0001 7.27285 40 7.27285V0C62.0914 0 80 17.9086 80 40Z",
    fill: "#F14635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaspiLoader);
export default __webpack_public_path__ + "static/media/kaspi-loader.46ae7816b63ec859ac054316839a7a2c.svg";
export { ForwardRef as ReactComponent };